/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable jsx-a11y/no-interactive-element-to-noninteractive-role */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import ChevronDownIcon from '@offerzen/zenicon/ChevronDownIcon'
import { colors } from '../../themes'
import AccessibleIcon from '../AccessibleIcon'
import styles from './styles'

const FilterMenu = ({
  selected,
  children,
  onSelect,
  defaultLabel,
  className,
  disabled,
  maxHeight,
  theme = 'primary',
  labelSize = 'default',
}) => {
  const [open, setOpen] = useState(false)
  const selectedLabel = React.Children.map(children, child => (child.props.id === selected ? child.props.label : '')).join('')

  return (
    <div className={cx(styles.wrapper, className)}>
      <button
        role="heading"
        type="button"
        onClick={() => setOpen(!open)}
        aria-haspopup="true"
        aria-expanded={open}
        className={cx(styles.label, labelSize === 'medium' ? styles.labelMedium : styles.labelDefault, disabled && styles.disabled)}
        tabIndex="0">
        <span>{selectedLabel || defaultLabel}</span>
        <AccessibleIcon icon={ChevronDownIcon} size={18} color={colors.grayChateau} />
      </button>
      {Boolean(open) && (
        <>
          <div className={styles.body}>
            <ul role="menu" className={cx(styles.list, maxHeight && styles.listMaxHeight(maxHeight))}>
              {React.Children.map(children, child =>
                React.cloneElement(child, {
                  theme,
                  active: child.props.id === selected,
                  onClick: () => {
                    if (onSelect) onSelect(child.props.id)
                    setOpen(false)
                  },
                }),
              )}
            </ul>
          </div>
          <div className={styles.overlay} onClick={() => setOpen(false)} />
        </>
      )}
    </div>
  )
}

FilterMenu.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  selected: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  defaultLabel: PropTypes.string,
  maxHeight: PropTypes.number,
  className: PropTypes.string,
  labelSize: PropTypes.oneOf(['', 'medium']),
}

export default FilterMenu
